import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ledgerDetailsConversion } from "../../../../report/sheet/ledger/conversions";
import { useSelector, useDispatch } from "react-redux";
import ReportCommonTable from "../../../../report/sheet/_common/table";
import { FormattedMessage, useIntl } from "react-intl";
import {
  clearEntriesParameters,
  getEntriesRead
} from "../../../../../store/actions/reports/balance/ledger";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import ReactToPrint from "react-to-print";
import moment from "moment";

const LedgerTab = ({ docDate, accountId, compoundedTitle }) => {
  const dispatch = useDispatch();
  const printPDF = useRef();
  const intl = useIntl();

  const additionalData = useSelector(state => state.reports?.search?.additionalData);
  const balanceDetails = ledgerDetailsConversion(additionalData?.balanceDetails);

  useEffect(() => {
    const fromDate = moment().startOf("year").format("YYYY-MM-DD");
    const toDate = docDate;
    if (!balanceDetails) {
      dispatch(getEntriesRead(
        accountId,
        "",
        fromDate,
        toDate
      ));
    }
    return () => {
      if (balanceDetails) {
        dispatch(clearEntriesParameters());
      }
    };
  }, []);

  return (
    <div data-testid="LedgerTab" className="ledger-tab-container">
      <div className="ledger-tab-container-icons">
        <CSVLink
          data={balanceDetails?.rows || []}
          filename={
            new Date().toDateString().replaceAll(" ", "_") + ".csv"
          }>
          <FontAwesomeIcon
            icon={["far", "download"]}
            style={{
              marginRight: 20,
              color: "#0090d1",
              cursor: "pointer"
            }}
          />
        </CSVLink>
        <ReactToPrint
          trigger={() => (
            <FontAwesomeIcon
              icon={["far", "print"]}
              style={{
                marginRight: 10,
                color: "#0090d1",
                cursor: "pointer"
              }}
            />
          )}
          content={() => printPDF.current}
        />
      </div>
      <div ref={printPDF}>
        <div className="ledger-tab-container-header">
          <div className="ledger-tab-container-header-left">
            <FormattedMessage id="preCog.drawerDetail.accountLedger" /> {accountId} - {compoundedTitle}
          </div>
          <div className="ledger-tab-container-header-right">
            <div className="ledger-tab-container-header-right-label">
              <FormattedMessage id="preCog.drawerDetail.initialBalance" />:{" "}
            </div>
            <div className="ledger-tab-container-header-right-number">
              {numeral(additionalData?.balanceDetails?.initialBalance).format("0,0.00")} €
            </div>
          </div>
        </div>
        <ReportCommonTable
          className={""}
          report={balanceDetails?.header ?
            balanceDetails :
            {
              header: [
                intl.formatMessage({ id: "preCog.label.registrationDate" }),
                intl.formatMessage({ id: "reports.vat.aliquoteDetail.docNumber" }), 
                intl.formatMessage({ id: "preCog.label.movimentDate" }),
                intl.formatMessage({ id: "preCog.header.reason" }),
                intl.formatMessage({ id: "preCog.accountingTab.amountDescription" }),
                " ",
                intl.formatMessage({ id: "generic.total" })],
              rows: []
            }}
        />
      </div>
    </div>);
};

export default LedgerTab;
